import { render, staticRenderFns } from "./user.vue?vue&type=template&id=f418aa2e&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
import style0 from "./user.vue?vue&type=style&index=0&id=f418aa2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f418aa2e",
  null
  
)

export default component.exports